module.exports = __webpack_public_path__ + "img/back-01.0c9d917f.png";